// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 16:14:17

export default {
  "id": "heritage-mahjong-classic",
  "slug": "heritage-mahjong-classic",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/10428f0c63f64674927f991b43854b1b-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/10428f0c63f64674927f991b43854b1b/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Heritage Mahjong Classic",
      "description": "Immerse yourself in a timeless Mahjong experience with Heritage Mahjong Classic. Featuring a single elegant layout, three unique tile skins, a time bonus for quick matches, and a competitive leaderboard, this game offers a simple yet captivating challenge. Perfect for players of all levels, enjoy a relaxing atmosphere as you match tiles, earn bonuses, and climb the ranks. Are you ready to test your skills and embrace the charm of classic Mahjong? Start your journey today!",
      "instructions": "Find and match identical tiles to remove them from the board. Ensure tiles are free on at least one side before matching. Clear all tiles to complete the layout and test your skills! Use the Hint feature to guide you through tricky situations. Enjoy a relaxing Mahjong experience with timeless gameplay, beautiful tile designs, and a competitive leaderboard!",
      "genres": [
        "Mahjong & Connect"
      ],
      "tags": [
        "classic"
      ]
    },
    "zh-CN": {
      "title": "传承麻将经典",
      "description": "沉浸于永恒的麻将体验，尽在《遗产麻将经典》。游戏特色包括单一种优雅布局、三种独特的牌面皮肤、快速匹配的计时奖励和竞争排行榜，提供简单却引人入胜的挑战。适合所有水平的玩家，在轻松的氛围中匹配牌面、赚取奖励并攀登排行榜。你准备好测试你的技能并拥抱经典麻将的魅力了吗？今天开始你的旅程吧！",
      "instructions": "找到并匹配相同的瓷砖以从棋盘上移除它们。确保在匹配前瓷砖至少有一边是空闲的。清除所有瓷砖以完成布局并测试你的技巧！使用提示功能来引导你通过困难的情况。享受轻松的麻将体验，永恒的游戏玩法，美丽的瓷砖设计和具有竞争力的排行榜！",
      "genres": [
        "麻将 & 连接"
      ],
      "tags": [
        "经典"
      ]
    },
    "zh-TW": {
      "title": "傳統麻將經典版",
      "description": "沉浸在永恒的麻將體驗中，歡迎來到 Heritage Mahjong Classic。特色為單一優雅的佈局、三種獨特的牌皮、快速匹配的時間獎勵以及競爭性的排行榜，這款遊戲提供簡單卻迷人的挑戰。適合所有級別的玩家，享受輕鬆的氣氛，當你匹配牌面、獲得獎勵並攀升排名時。你準備好測試你的技巧並欣賞經典麻將的魅力了嗎？今天開始你的旅程吧！",
      "instructions": "尋找並匹配相同的磁磚以從遊戲板上移除它們。在匹配之前，確保磁磚至少有一邊是自由的。清除所有磁磚以完成佈局並挑戰你的技巧！使用提示功能來幫助你通過困難的情況。享受一場輕鬆的麻將體驗，經典的遊戲玩法，美麗的磁磚設計，以及競爭激烈的排行榜！",
      "genres": [
        "麻將 & 連線"
      ],
      "tags": [
        "經典"
      ]
    },
    "zh-HK": {
      "title": "傳統麻將經典版",
      "description": "沉浸在經典麻將的不朽體驗中，盡在 Heritage Mahjong Classic。遊戲特色包括單一雅緻的佈局、三種獨特的牌皮、時間獎勵及競賽排行榜。遊戲簡單卻吸引人，適合各級別玩家。享受輕鬆的遊戲氛圍，配對牌片、獲得獎勵、奪取排名。你準備好挑戰自我，欣賞經典麻將的魅力了嗎？今日起啟航你的冒險之旅！",
      "instructions": "尋找並匹配相同的磁片以將其從棋盤上移除。在匹配前確保磁片至少一邊是自由的。清空所有磁片以完成佈局並挑戰自己的技巧！使用提示功能來協助你度過難關。享受這款經典的麻將遊戲體驗，美麗的磁片設計，以及競爭激烈的排行榜！",
      "genres": [
        "麻將 & 連線"
      ],
      "tags": [
        "經典"
      ]
    },
    "ja": {
      "title": "遺産麻雀クラシック",
      "description": "時間を超えたマージョン体験に没頭してみてください、Heritage Mahjong Classic。シンプルでエレガントなレイアウト、3種類のユニークなタイルスキン、速いマッチングのためのタイムボーナス、競争的なリーダーボードを特徴とするこのゲームは、シンプルで魅力的な挑戦を提供します。全てのレベルのプレイヤーに最適で、タイルをマッチングし、ボーナスを獲得し、ランクを上げるのを楽しみながらリラックスした雰囲気を満喫してください。あなたのスキルを試し、古典的なマージョンの魅力を受け入れる準備はできましたか？今日からあなたの旅を始めましょう！",
      "instructions": "同じタイルを見つけ、一致させてボードから取り除きましょう。一致させる前に、少なくとも1面が開いているタイルを使用してください。すべてのタイルをクリアしてレイアウトを完了し、スキルを試してみましょう！ヒント機能を使用して、困難な状況を導き出しましょう。時代を超えた遊び方、美しいタイルデザイン、競争力のあるリーダーボードでリラックスしたマージョン体験をお楽しみください！",
      "genres": [
        "麻雀 & コネクト"
      ],
      "tags": [
        "クラシック"
      ]
    },
    "ko": {
      "title": "Heritage 마작 클래식",
      "description": "헤리티지 마ахjong 클래식을 통해 영원한 마ахjong 체험에 빠져 보세요. 단일하고 우아한 레이아웃, 세 가지 독특한 타일 스킨, 빠른 매치를 위한 시간 보너스, 그리고 경쟁적인 랭킹 보드로 구성된 이 게임은 간단하지만 매력적인 도전을 제공합니다. 모든 수준의 플레이어에게 적합한 이 게임은 타일을 맞추며 보너스를 획득하고 랭킹을 올릴 수 있는 휴식적인 분위기를 제공합니다. 클래식 마ахjong의 매력을 테스트하고 싶으신가요? 오늘부터 여정을 시작하세요!",
      "instructions": "동일한 타일을 찾아서 일치시켜 보드에서 제거하세요. 일치시키기 전에 타일이 최소한 한 쪽이 자유롭아야 합니다. 모든 타일을 클리어하여 레이아웃을 완료하고 기술을 테스트하세요! 어려운 상황에서 가이드를 받기 위해 힌트 기능을 사용하세요. 영원한 게임플레이, 아름다운 타일 디자인, 경쟁적인 랭킹보드와 함께 편안한 마작 경험을 즐겨보세요!",
      "genres": [
        "마작 & 커넥트"
      ],
      "tags": [
        "클래식"
      ]
    },
    "fr": {
      "title": "Héritage Mahjong Classique",
      "description": "Immergez-vous dans une expérience de Mahjong éternelle avec Heritage Mahjong Classic. Doté d'une disposition élégante unique, de trois skins de tuiles uniques, d'un bonus de temps pour les parties rapides et d'un classement compétitif, ce jeu propose un défi simple mais captivant. Idéal pour les joueurs de tous niveaux, profitez d'un atmosphère relaxante tout en alignant des tuiles, gagnant des bonus et grimpant dans les rangs. Prêt à tester vos compétences et à embracez le charme du Mahjong classique ? Commencez votre aventure aujourd'hui !",
      "instructions": "Trouvez et matchez des tuiles identiques pour les enlever du plateau. Assurez-vous que les tuiles soient libres d'au moins un côté avant de les matchez. Éliminez toutes les tuiles pour terminer le plateau et tester vos compétences ! Utilisez la fonction Aide pour vous guider à travers des situations délicates. Profitez d'une expérience de Mahjong apaisante avec un gameplay éternel, des designs de tuiles magnifiques et un classement compétitif !",
      "genres": [
        "Mahjong et Connect"
      ],
      "tags": [
        "classique"
      ]
    }
  }
};
